import React from 'react'
import Chip from '@mui/material/Chip';
import AvatarName from "../AvatarName";
import "./attendeeChip.scss";

const AvatarChip = ({name, index, noBorders}) => {
    return <Chip
            variant={noBorders ? "filled" : "outlined" }
            label={name}
            avatar={<AvatarName name={name} index={index} overlap={false} />}
            className={`avatar-name ${noBorders ? "no-border-avatar-chip" : "bordered-avatar-chip"}`}
            sx={{ margin: '4px 8px 4px 0px', background: "none"}}/>
}

export default AvatarChip